export namespace Const {
  /**
   * DB区分
   */
  export const DB_KBN = {
    ZERO: '0',
    FIRST: '1',
    SECOND: '2',
  };
  /**
   * ローカルストレージ定数
   */
  export const LOCAL_STORAGE_VALUE = {
    COMPANY_CD: 'companyCd',
    COMPANY_NAME: 'companyName',
    ACCOUNT_ID: 'accountId',
    TANTO_NAME: 'tanName',
    TOKUISAKI_CD: 'tokCd',
    TOKUISAKI_CD2: 'tokCd2',
    KYOTEN_CD: 'kyotenCd',
    JISHA_KBN: 'jishaKbn',
    JYU_NO: 'jyuNo',
    JWT: 'jwt',
    MOVE_KBN: 'moveKbn',
  };
  /**
   * 共通コードマスタ_コード区分定数
   */
  export const MCODE_KBN_CODE = {
    AMPM_CODE: 'K07',
    KAITO_STATUS_CODE: 'K15',
  };
  /**
   * 結果コード
   */
  export const RESULT_CODE = {
    SUCCESS: 'SUCCESS',
    ACCOUNT_LOCK: 'ERR002',
    INIT_PASSWORD: 'ERR003',
    EXPIRED_PASS: 'ERR004',
    NG_PASS: 'ERR005',
    ILLEGAL_PASS: 'ERR007',
    DUPLICATE_PASS: 'ERR008',
    NOT_EXIST_MAIL_ADD: 'ERR009',
    NOT_EXIST_HINMOKU_INFO: 'ERR010',
    NOT_EXIST_KOJI_KANRI_NO: 'ERR011',
    NOT_EXIST_JUCHU: 'ERR012',
    DELETED_JUCHU: 'ERR013',
    NOT_EXIST_ACCOUNT: 'ERR014',
    DIFFERENT_PASS: 'ERR015',
    SYSTEM_ERR: 'ERR999',
  };

  // 処理区分
  export const SHORI_KBN = {
    Create: '1',
    Edit: '2',
    Delete: '3',
    Show: '4',
  };

  // 受注照会_検索条件
  export const JUCHU_SHOKAI_SEARCH_INFO = {
    TOKUISAKI_CD: 'tokCd',
    TOKUISAKI_CD2: 'tokCd2',
    NOKI_KAITO: 'nokiKaito',
    DATE_FROM: 'dateFrom',
    DATE_TO: 'dateTo',
    ORDER_NO: 'orderNo',
    SHIPSTATUS: 'shipStatus',
    NOU_CD: 'nouCd',
    PRODUCT_CD: 'productCd',
    PRODUCT_NM: 'productNm',
    COLOR: 'color',
    PRODUCT_HUB: 'prductHub',
    EXECUTE: 'execute',
  };
}
